import { put, takeLatest } from 'redux-saga/effects';
import { VERIFY_EMAIL, VERIFY_EMAIL_FAIL, VERIFY_EMAIL_SUCCESS } from '../actions/actionTypes';
import { ApiService } from '../services/ApiService';

const _apiService = new ApiService();

function* verifyEmail(action) {
  try {
    const response = yield _apiService.postVerifyEmail(action.params);

    if (!response || response.error) {
      yield put({
        type: VERIFY_EMAIL_FAIL,
        message: response.error
      });
    }
    else {
      yield put({
        type: VERIFY_EMAIL_SUCCESS
      });
    }
  } catch (error) {
    yield put({
      type: VERIFY_EMAIL_FAIL,
      message: error.message
    });
  }
}

export function* watchVerifyEmail() {
  yield takeLatest(VERIFY_EMAIL, verifyEmail);
}
